export const ICON_SIZE_PX: Record<string, number> = {
  xs: 16,
  s: 20,
  m: 24,
  l: 28
};

export const SPINNER_SIZE_WITH_TEXT_PX: Record<string, number> = {
  xs: 10,
  s: 12,
  m: 14,
  l: 14
};
